import { useState } from "react";
import { PageHeader } from "@shared/components/PageHeader";
import { Card } from "@shared/ui/card";
import { KpiCards } from "./kpiCards";
import { ReaderPerformance } from "./readerPerformance";
import { HistoricalPerformance } from "./historicalPerformance";
import { MeterReadingQuality } from "./readingQualityCard";
import { SummaryCard } from "./summaryCard";
import {
  useGetPerformanceDashboard,
  useMeterCycle,
  useGetPerformanceDetails,
} from "@features/mx/routeManagement/hooks";
import { useParams } from "react-router-dom";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/ui/select";

export const PerformanceTabLanding = () => {
  const { route_id } = useParams();
  const { data: meterCycleData } = useMeterCycle(route_id);
  const [selectedMeterCycleId, setSelectedMeterCycleId] = useState<number | null>(null);

  const meterCycleOptions =
    meterCycleData?.results?.map((item: any) => ({
      label: item.meterCycleName,
      value: item.id,
    })) || [];

  const { data: performanceDetails, isLoading } = useGetPerformanceDetails(
    route_id,
    selectedMeterCycleId ?? undefined
  );
  const readingStats = performanceDetails?.readingStats;

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
        <PageHeader
          title="Performance"
          subtitle="Metrics and trends for the selected read cycle."
        />

        {/* Dropdown */}
        <div className="mt-3 lg:mt-0 w-full lg:w-60">
          <Select onValueChange={(value) => setSelectedMeterCycleId(Number(value))}>
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Select Meter Cycle" />
            </SelectTrigger>
            <SelectContent>
              {meterCycleOptions.map((option) => (
                <SelectItem key={option.value} value={String(option.value)}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* KPI Metrics Row */}
      <KpiCards data={performanceDetails} />

      {/* Summary Section */}
      <Card className="shadow-sm">
        <SummaryCard data={performanceDetails} />
      </Card>

      {/* Middle Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
       <MeterReadingQuality
  data={{
    normalCount: readingStats?.normalCount,
    normalPercentage: readingStats?.normalPercentage,
    faultyCount: readingStats?.faultyCount,
    faultyPercentage: readingStats?.faultyPercentage,
    rcntCount: readingStats?.rcntCount,
    rcntPercentage: readingStats?.rcntPercentage,
  }}
/>
        <ReaderPerformance data={performanceDetails?.meterReaderPerformance} />
      </div>

      {/* Bottom Section */}
      <Card className="shadow-sm">
        <HistoricalPerformance data={performanceDetails?.historicalPerformance} />
      </Card>
    </div>
  );
};
